export default "__VITE_ASSET__B9fufN7t__"